import { useState } from 'react';
import { Col, Row, Space } from 'antd';
import { MonetizationFiltersBar } from './MonetizationFiltersBar';
import { MonetizationKpiCards } from './MonetizationKpiCards';
import { MonetizationProductMixChart } from './MonetizationProductMixChart';
import { MonetizationRenewalStatusChart } from './MonetizationRenewalStatusChart';
import { MonetizationSystemHealthCard } from './MonetizationSystemHealthCard';
import { MonetizationTrendChart } from './MonetizationTrendChart';
import type { MonetizationStatsFilters } from './filters';

export const MonetizationTabContent = () => {
  const [filters, setFilters] = useState<MonetizationStatsFilters>({});

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <MonetizationFiltersBar value={filters} onChange={setFilters} />
      <MonetizationKpiCards filters={filters} />
      <MonetizationTrendChart filters={filters} />
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={14}>
          <MonetizationProductMixChart filters={filters} />
        </Col>
        <Col xs={24} lg={10}>
          <MonetizationRenewalStatusChart filters={filters} />
        </Col>
      </Row>
      <MonetizationSystemHealthCard />
    </Space>
  );
};
